import { Component, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';

import { User } from '../../models/user/user-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UserService } from '../../services/user/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RoleService } from '../../services/role/role.service';
import { StateService } from '../../services/state/state.service';
import { CountryService } from '../../services/country/country.service';
import { ProfileService } from '../../services/profile/profile.service';

import { Role } from '../../models/shared/role.model';
import { Country } from '../../models/country/country-model';
import { State } from '../../models/state/state-model';

@Component({
  selector: 'app-profile-edit',
  templateUrl: './profile-update.component.html',
  styleUrls: ['./profile-update.component.css']
})
/** user-edit component*/
export class ProfileUpdateComponent {

  userModel = new User();
  userID: string;
  errorMessage: any;

  roleList: Role[] = [];
  countryList: Country[] = [];
  stateList: State[] = []
  isSubmitted = false;

  public dateOfBirthElement : any;

  profileImage = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
  isDefaultImg = true;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;

  modalRef: BsModalRef;
  config = {
    animated: true
  };

  /** user-edit ctor */
  constructor(private readonly userService: UserService,
    private readonly roleService: RoleService,
    private readonly countryService: CountryService,
    private readonly stateService: StateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly profileService: ProfileService,
    private readonly toastr: ToastsManager,
    private readonly router: Router, vcr: ViewContainerRef,
    private modalService: BsModalService) {
    this.toastr.setRootViewContainerRef(vcr);

    this.userModel.roleID = "";
    this.userModel.countryID = "";
    this.userModel.stateID = "";
    this.GetCountries();
    this.GetRoles();

    this.activatedRoute.params.subscribe((params: Params) => {
      this.userID = params['id'];
    });
  }

  openModal(template: TemplateRef<any>) { 
    this.modalRef = this.modalService.show(template, this.config);
  }

  confirm(): void {
    this.profileImage = this.croppedImage;
    this.modalRef.hide();
  }

  decline(): void {

    if (this.profileImage != this.croppedImage && this.isDefaultImg) {
      this.imageChangedEvent = "";
      this.croppedImage = "";
    }
    this.modalRef.hide();
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCroppedBase64(image: string) {
    this.croppedImage = image;
  }
  imageLoaded() {
    this.cropperReady = true;

    //if (!this.isDefaultImg) {
      this.croppedImage = this.profileImage;
    //}
  }
  imageLoadFailed() {
    
  }

  GetProfile() {
    this.profileService.getProfile().subscribe(
      data => { 
        if (data) {
          this.userModel = data;
          this.userModel.dateOfBirth = new Date(this.userModel.dateOfBirth);
          this.profileImage = this.userModel.imagePath;
          if (this.userModel.countryID) {
            this.GetStatesByCountry({
              target: {
                value: this.userModel.countryID
              }
            });
          }
          else {
            this.userModel.countryID = "";
          }

          if (this.userModel.roleID == null) {
            this.userModel.roleID = "";
          } 
          
          this.isDefaultImg = false;
        }
      }
    )
  }

  DefaultImg() {
    this.profileImage = "http://ssl.gstatic.com/accounts/ui/avatar_2x.png";
    this.isDefaultImg = true;
  }

  GetRoles() {
    this.roleService.GetRoles().subscribe(
      data => {
        this.roleList = data;
      });
  }

  GetStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.stateList = data;

        if (this.userModel.stateID == null || this.userModel.stateID == "") {
          this.userModel.stateID = "";
        }
      });
  }

  GetCountries() {
    this.countryService.getCountries().subscribe(
      data => {
        this.countryList = data;
        this.GetProfile();
      });
  }

  ngSubmit() {

    this.isSubmitted = true;
    this.userModel.imagePath = this.croppedImage;
    this.profileService.updateProfile(this.userModel).subscribe(result => {
      if (result) {
        this.toastr.success('Profile has been updated', 'Success');

        setTimeout(() => {
          this.router.navigate(["/profile"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
        this.isSubmitted = false;
      }
    });
  }
}







// WEBPACK FOOTER //
// ./src/app/profile-components/profile-update/profile-update.component.ts